export default __webpack_public_path__ + "static/media/020_start.first.13b8ac92.avif";